import React, { useState, useRef, useEffect } from 'react';
import {
  FiMail,
  FiClock,
  FiAlertCircle,
  FiArchive,
  FiTrash2,
  FiArrowRightCircle,
} from 'react-icons/fi';
import { FiAlertTriangle, FiFlag, FiCheckCircle } from 'react-icons/fi';

import EmailComponent from './EmailModal';

function getSenderNameOrEmail(fromString) {
  // Check if the string contains a sender name
  if (fromString.includes('<')) {
    // Extract the part before `<` (the name)
    return fromString.split('<')[0].trim();
  } else {
    // If no `<`, return the full email
    return fromString.trim();
  }
}
function getDayAndMonth(dateString) {
  // Convert to Date object
  const date = new Date(dateString);
  // Format day and month
  const day = date.getDate(); // Day of the month
  const month = date.toLocaleString('en-IN', { month: 'short' }); // Short month name
  return `${day} ${month}`;
}

const convertOutlookToUniformFormat = (outlookEmailList) => {
  return outlookEmailList.map((outlookMail) => {
    return {
      ...outlookMail,
      snippet: outlookMail.bodyPreview,
      priority: outlookMail.importance,
    };
  });
};

const EmailList = ({ emailList, isOutlook = false }) => {
  const [hoveredRow, setHoveredRow] = useState(null);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const uniformEmailList = !isOutlook
    ? [...emailList]
    : convertOutlookToUniformFormat(emailList);
  // const [isHovered, setIsHovered] = useState(false);
  const [isScaled, setIsScaled] = useState(false);
  const scaledRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (scaledRef.current && !scaledRef.current.contains(event.target)) {
        setIsScaled(false);
      }
    };

    if (isScaled) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isScaled]);

  const closeModal = () => {
    setSelectedEmail(null);
    setIsModalOpen(false);
  };

  const openEmailModal = (email) => () => {
    setSelectedEmail(email);
    setIsModalOpen(true);
  };
  if (!emailList || emailList.length === 0) {
    return null;
  }

  return (
    <div className="flex w-full items-center justify-center gap-2 pt-0 sm:justify-start">
      {/* <div className="hidden sm:block h-10 w-10"></div> */}
      {/* Desktop Email Table view*/}
      {/* eslint-disable-next-line */}
      <div
        onClick={() => setIsScaled(true)}
        className={`mb-4 hidden  w-full cursor-pointer overflow-x-auto rounded-lg border border-gray-200 shadow-md sm:block sm:w-full
        ${isScaled ? 'opacity-0' : 'opacity-100 '}`}
      >
        {/* <div className="overflow-x-auto w-full overflow-y-auto max-h-[300px] scrollbar-none pointer-events-none"> */}
        <div className="no-scrollbar max-h-[300px] w-full overflow-y-auto  overflow-x-hidden">
          <table className="min-w-full border-collapse divide-y divide-gray-200 rounded-t-lg bg-white">
            <thead className="rounded-lg ">
              <tr className="rounded-lg bg-gray-100">
                <th
                  scope="col"
                  className="px-2 py-1 text-left text-sm font-medium text-gray-600"
                >
                  Sender
                </th>
                <th
                  scope="col"
                  className="px-2 py-1 text-left text-sm font-medium text-gray-600"
                >
                  Snippet
                </th>
                <th
                  scope="col"
                  className="px-2 py-1 text-left text-sm font-medium text-gray-600"
                >
                  Time
                </th>
                <th
                  scope="col"
                  className="px-2 py-1 text-left text-sm font-medium text-gray-600"
                >
                  Priority
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {uniformEmailList?.map((email, index) => {
                // const display = email.subject ? <><span className='text-gray-800'>{email.subject.slice(0, 70) + " "}</span> {((email?.snippet || "").length <= (69 - email.subject.length)) ? (email?.snippet || "") : (email?.snippet || "").slice(0, 70 - email.subject.length - 1) + "..."}</> : (email?.snippet || "").length <= 70 ? (email?.snippet || "") : (email?.snippet || "").slice(0, 70) + "...";
                const subject = email?.subject || '';
                const snippet = email?.snippet || '';

                let display1 = '';

                if (subject) {
                  const remainingLength = 70 - subject.length - 1; // -1 for the space between subject and snippet
                  display1 =
                    subject.length >= 70 ? (
                      <span className="text-gray-800">
                        {' '}
                        {subject.slice(0, 70)}{' '}
                      </span>
                    ) : (
                      <>
                        <span className="text-gray-800">
                          {' '}
                          {subject.slice(0, 70)}{' '}
                        </span>
                        {' ' + snippet.length <= remainingLength
                          ? snippet
                          : snippet.slice(0, remainingLength) + '...'}{' '}
                      </>
                    );
                } else {
                  display1 =
                    snippet.length <= 70
                      ? snippet
                      : snippet.slice(0, 67) + '...';
                }
                return (
                  <tr
                    key={index}
                    className=" cursor-pointer hover:bg-gray-50"
                    onMouseEnter={() => setHoveredRow(index)}
                    onMouseLeave={() => setHoveredRow(null)}
                    onClick={openEmailModal(email)}
                  >
                    {/* <td className="px-2 py-1 text-sm font-medium text-gray-900 whitespace-nowrap"> */}
                    <td className="px-2 py-1 text-sm font-medium text-gray-900 ">
                      <div className="flex items-center">
                        <FiMail className="mr-1 text-[#5652CF]" size={14} />
                        {isOutlook
                          ? email.from?.name
                          : getSenderNameOrEmail(email.from)}
                      </div>
                    </td>
                    <td className="whitespace-nowrap px-2 py-1 text-sm font-semibold text-gray-500">
                      {display1}
                      {/* {((email.subject || "") + (email?.snippet || "")).length > 70 ? <><span>{(email.subject || "").slice(email.subject?.length || 0, 70)}</span> {(email?.snippet || "").slice(0, 70) + "..." }</>: <><span>{(email.subject || "").slice(email.subject?.length || 0, 70)}</span> {(email?.snippet || "").slice(0, 70) } </>} */}
                    </td>
                    <td className="whitespace-nowrap px-2 py-1 text-sm text-gray-500">
                      {hoveredRow === index ? (
                        <div className="flex items-center space-x-1 font-semibold">
                          <FiArchive
                            className="text-gray-700 hover:text-gray-700"
                            size={14}
                          />
                          <FiTrash2
                            className="text-gray-700 hover:text-gray-700"
                            size={14}
                          />
                          <FiArrowRightCircle
                            className="text-gray-700 hover:text-gray-700"
                            size={14}
                          />
                        </div>
                      ) : (
                        <div className="flex items-center">
                          <FiClock className="mr-1 text-gray-400" size={14} />
                          {getDayAndMonth(email.date)}
                        </div>
                      )}
                    </td>
                    <td className="whitespace-nowrap px-2 py-1 text-sm font-medium">
                      <span
                        className={`flex items-center rounded-lg px-1 py-0.5 text-sm font-semibold ${
                          email.priority === 'Critical'
                            ? 'bg-red-100 text-red-600'
                            : email.priority === 'High'
                              ? 'bg-orange-100 text-orange-600'
                              : email.priority === 'Medium'
                                ? 'bg-yellow-100 text-yellow-600'
                                : email.priority === 'Low'
                                  ? 'bg-green-100 text-green-600'
                                  : 'bg-gray-100 text-gray-600'
                        }`}
                      >
                        {email.priority === 'Critical' && (
                          <FiAlertCircle
                            className="mr-1 text-red-600"
                            size={12}
                          />
                        )}
                        {email.priority === 'High' && (
                          <FiAlertTriangle
                            className="mr-1 text-orange-600"
                            size={12}
                          />
                        )}
                        {email.priority === 'Medium' && (
                          <FiFlag className="mr-1 text-yellow-600" size={12} />
                        )}
                        {email.priority === 'Low' && (
                          <FiCheckCircle
                            className="mr-1 text-green-600"
                            size={12}
                          />
                        )}
                        {email.priority || 'Normal'}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile Email Card View */}
      <div
        className={`mb-4 block  w-full cursor-pointer overflow-x-auto rounded-lg border border-zinc-200 bg-zinc-700 p-2 shadow-md sm:hidden sm:w-[88%]`}
      >
        <div className="scrollbar-none max-h-[60vh] w-full space-y-2  overflow-y-auto">
          {uniformEmailList?.map((email, index) => {
            const subject = email?.subject || '';
            const snippet = email?.snippet || '';
            const displayText = subject
              ? `${subject} ${snippet.slice(0, Math.max(0, 70 - subject.length - 1))}...`
              : snippet.slice(0, 70) + '...';

            return (
              // eslint-disable-next-line
              <div
                key={index}
                onClick={openEmailModal(email)}
                className={`cursor-pointer rounded-lg border border-gray-200 bg-white p-3 shadow-sm ${
                  !email.isRead ? 'font-bold' : ''
                }`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <FiMail className="text-[#5652CF]" />
                    <span className="text-sm font-medium text-gray-900">
                      {isOutlook
                        ? email.from?.name
                        : getSenderNameOrEmail(email.from)}
                    </span>
                  </div>
                  <div className="flex items-center text-xs text-gray-500">
                    <FiClock className="mr-1" size={12} />
                    {getDayAndMonth(email.date)}
                  </div>
                </div>

                <div className="mt-2 flex justify-between gap-2">
                  <div className=" overflow-hidden text-ellipsis whitespace-nowrap text-sm text-gray-600">
                    {displayText}
                  </div>
                  <span
                    className={`flex items-center rounded-lg px-2 py-0.5 text-xs font-semibold ${
                      email.priority === 'Critical'
                        ? 'bg-red-100 text-red-600'
                        : email.priority === 'High'
                          ? 'bg-orange-100 text-orange-600'
                          : email.priority === 'Medium'
                            ? 'bg-yellow-100 text-yellow-600'
                            : email.priority === 'Low'
                              ? 'bg-green-100 text-green-600'
                              : 'bg-gray-100 text-gray-600'
                    }`}
                  >
                    {email.priority === 'Critical' && (
                      <FiAlertCircle className="mr-1" size={12} />
                    )}
                    {email.priority === 'High' && (
                      <FiAlertTriangle className="mr-1" size={12} />
                    )}
                    {email.priority === 'Medium' && (
                      <FiFlag className="mr-1" size={12} />
                    )}
                    {email.priority === 'Low' && (
                      <FiCheckCircle className="mr-1" size={12} />
                    )}
                    {email.priority || 'Normal'}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {isScaled && (
        <div className="duration-600 fixed inset-0 z-50 flex transform items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm transition-all ease-in-out max-sm:p-3 sm:mr-10 ">
          <div
            // onMouseEnter={() => setIsHovered(true)}
            // onMouseLeave={() => setIsHovered(false)}
            ref={scaledRef}
            className="max-h-[600px] w-full items-center justify-center overflow-hidden rounded-xl bg-white sm:w-[60%] "
          >
            <div className="scrollbar-none max-h-[600px] w-full overflow-x-auto overflow-y-auto">
              <table className="min-w-full border-collapse divide-y divide-gray-200 rounded-t-lg bg-white">
                <thead className="rounded-lg ">
                  <tr className="rounded-lg bg-gray-100">
                    <th
                      scope="col"
                      className="px-3 py-2 text-left text-sm font-medium text-gray-600"
                    >
                      Sender
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-2 text-left text-sm font-medium text-gray-600"
                    >
                      Snippet
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-2 text-left text-sm font-medium text-gray-600"
                    >
                      Time
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-2 text-left text-sm font-medium text-gray-600"
                    >
                      Priority
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {uniformEmailList?.map((email, index) => {
                    // const display = email.subject ? <><span className='text-gray-800'>{email.subject.slice(0, 70) + " "}</span> {((email?.snippet || "").length <= (69 - email.subject.length)) ? (email?.snippet || "") : (email?.snippet || "").slice(0, 70 - email.subject.length - 1) + "..."}</> : (email?.snippet || "").length <= 70 ? (email?.snippet || "") : (email?.snippet || "").slice(0, 70) + "...";
                    const subject = email?.subject || '';
                    const snippet = email?.snippet || '';

                    let display1 = '';

                    if (subject) {
                      const remainingLength = 70 - subject.length - 1; // -1 for the space between subject and snippet
                      display1 =
                        subject.length >= 70 ? (
                          <span className="text-gray-800">
                            {' '}
                            {subject.slice(0, 70)}{' '}
                          </span>
                        ) : (
                          <>
                            <span className="text-gray-800">
                              {' '}
                              {subject.slice(0, 70)}{' '}
                            </span>
                            {' ' + snippet.length <= remainingLength
                              ? snippet
                              : snippet.slice(0, remainingLength) + '...'}{' '}
                          </>
                        );
                    } else {
                      display1 =
                        snippet.length <= 70
                          ? snippet
                          : snippet.slice(0, 67) + '...';
                    }
                    return (
                      <tr
                        key={index}
                        className={`cursor-pointer hover:bg-gray-50 ${!email.isRead ? 'font-bold' : ''} `}
                        onMouseEnter={() => setHoveredRow(index)}
                        onMouseLeave={() => setHoveredRow(null)}
                        onClick={openEmailModal(email)}
                      >
                        <td className="whitespace-nowrap px-3 py-2 text-sm font-medium text-gray-900">
                          <div className="flex items-center">
                            <FiMail className="mr-2 text-[#5652CF]" />
                            {isOutlook
                              ? email.from?.name
                              : getSenderNameOrEmail(email.from)}
                          </div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-2 text-sm font-semibold text-gray-500">
                          {display1}
                          {/* {((email.subject || "") + (email?.snippet || "")).length > 70 ? <><span>{(email.subject || "").slice(email.subject?.length || 0, 70)}</span> {(email?.snippet || "").slice(0, 70) + "..." }</>: <><span>{(email.subject || "").slice(email.subject?.length || 0, 70)}</span> {(email?.snippet || "").slice(0, 70) } </>} */}
                        </td>
                        <td className="whitespace-nowrap px-3 py-2 text-sm text-gray-500">
                          {hoveredRow === index ? (
                            <div className="flex items-center space-x-2 font-semibold">
                              <FiArchive
                                className="text-gray-700 hover:text-gray-700"
                                size={15}
                              />
                              <FiTrash2
                                className="text-gray-700 hover:text-gray-700"
                                size={15}
                              />
                              <FiArrowRightCircle
                                className="text-gray-700 hover:text-gray-700"
                                size={15}
                              />
                            </div>
                          ) : (
                            <div className="flex items-center">
                              <FiClock className="mr-2 text-gray-400" />
                              {getDayAndMonth(email.date)}
                            </div>
                          )}
                        </td>
                        <td className="whitespace-nowrap px-3 py-2 text-sm font-medium">
                          <span
                            className={`flex items-center rounded-xl px-2 py-1 text-xs font-semibold ${
                              email.priority === 'Critical'
                                ? 'bg-red-100 text-red-600'
                                : email.priority === 'High'
                                  ? 'bg-orange-100 text-orange-600'
                                  : email.priority === 'Medium'
                                    ? 'bg-yellow-100 text-yellow-600'
                                    : email.priority === 'Low'
                                      ? 'bg-green-100 text-green-600'
                                      : 'bg-gray-100 text-gray-600'
                            }`}
                          >
                            {email.priority === 'Critical' && (
                              <FiAlertCircle className="mr-2 text-red-600" />
                            )}
                            {email.priority === 'High' && (
                              <FiAlertTriangle className="mr-2 text-orange-600" />
                            )}
                            {email.priority === 'Medium' && (
                              <FiFlag className="mr-2 text-yellow-600" />
                            )}
                            {email.priority === 'Low' && (
                              <FiCheckCircle className="mr-2 text-green-600" />
                            )}
                            {email.priority || 'Normal'}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {isModalOpen && (
        <EmailComponent
          isOutlook={isOutlook}
          messageId={selectedEmail.id}
          analytics={{ snippet: '', priority: '', insights: '' }}
          onClose={closeModal}
        />
      )}
    </div>
  );
};

export default EmailList;
